//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ServiceInstalmentKind {
	Activation = 0,
	Instalment = 1,
	Rollback = 2
}
